import React from 'react';
import { useTranslation } from "react-i18next";

function MangistauSightPage(props) 
{
    const { t } = useTranslation();

    return (
        <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
            <h1 className="uk-heading-medium uk-margin-bottom">
                {t("mangistau.title", "Mangistau Region")}
            </h1>

            <p className="uk-text-lead uk-margin-bottom">
                {t(
                    "mangistau.intro",
                    "Mangistau, located in western Kazakhstan on the Caspian Sea, is famous for its dramatic desert landscapes, unique geological formations, and sacred sites. It is often described as one of the most otherworldly places in the country."
                )}
            </p>

            <h2 className="uk-heading-line uk-text-bold">
                <span>{t("mangistau.highlightsTitle", "Highlights")}</span>
            </h2>
            <ul className="uk-list uk-list-bullet uk-margin-bottom">
                <li>{t("mangistau.highlight1", "The Boszhira Valley, with surreal chalk cliffs and canyons resembling a lunar landscape.")}</li>
                <li>{t("mangistau.highlight2", "Torysh Valley of Balls, a field of mysterious spherical rock formations.")}</li>
                <li>{t("mangistau.highlight3", "Shakpak Ata Underground Mosque, carved directly into the rock and serving as a spiritual site.")}</li>
                <li>{t("mangistau.highlight4", "The Caspian Sea coastline, combining desert scenery with maritime views.")}</li>
                <li>{t("mangistau.highlight5", "Underground necropolises and mausoleums, reflecting the region’s deep cultural heritage.")}</li>
            </ul>

            <p className="uk-text uk-text-justify">
                {t(
                    "mangistau.conclusion",
                    "Mangistau is a land of contrasts where endless steppe meets the sea, and ancient history coexists with natural wonders. It is one of the most striking and unforgettable regions of Kazakhstan."
                )}
            </p>
        </div>
    );
}

export default MangistauSightPage;
